export default "__VITE_ASSET__BonFLCRz__"